import React, { useContext } from "react";
import { Route, Router, Switch } from "react-router-dom";
import Admin from "./components/Admin/Admin";
import ErrorPage from "./components/ErrorPage/ErrorPage";
import Home from "./components/Home/Home";
import StatsPage from "./components/Stats/StatsPage";
import { SettingsContext } from "./contexts/SettingsContext";
import history from './History';
import GridSettings from "./components/GridSettings/GridSettings";
import ThemeConfig from "./components/Theme/ThemeConfig";
import ThemeDisplay from "./components/Theme/ThemeDisplay";
import CustomTheme from "./components/Theme/CustomTheme";
import GridDisplay from "./components/GridDisplay/GridDisplay";
import TableStats from "./components/Stats/TableStats";

function Routes() {

    return(
        <Router history={history}>
            <Switch>
                <Route path="/CM2WebShare/" exact><Home /></Route> 
                <Route path="/CM2WebShare/GridSettings" exact><GridSettings /></Route> 
                <Route path="/CM2WebShare/Grid" exact><GridDisplay /></Route> 
                <Route path="/CM2WebShare/Admin" exact><Admin /></Route>
                <Route path="/CM2WebShare/Themes" exact><ThemeDisplay /></Route>
                <Route path="/CM2WebShare/ThemeSettings" exact><ThemeConfig /></Route>
                <Route path="/CM2WebShare/UploadTheme" exact><CustomTheme /></Route>
                <Route path="/CM2WebShare/Error" render={(props) => (
                    <ErrorPage title={props?.location?.state?.title} message={props?.location?.state?.message} />
                )}/>
                <Route path="/CM2WebShare/Statistics" render={(props) => (
                    <StatsPage />
                )} />
                <Route path="/CM2WebShare/TableStats" render={(props) => (
                    <TableStats />
                )}/>
            </Switch>
        </Router>
    );
}

export default Routes;